import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

import { LedgerAccountKindMap } from './LedgerAccountKind.enum';

type Props<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export function LedgerAccountKindPicker<TMultiple extends boolean>(
  props: Props<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return LedgerAccountKindMap.map((id) => {
      return {
        id,
        name: t(`GENERAL_LEDGER_ACCOUNT_TYPE.${id}`),
      };
    }).sort((a, b) => a.name.localeCompare(b.name));
  }, [t]);

  return <FixedDataPicker dataSet={data} {...props} />;
}
